import React from "react";
import "./grid.scss";
import cx from "classnames";

interface GridBackgroundProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  deployUrl?: string;
  disableScale?: boolean;
  disableCursor?: boolean;
}

export function GridBackground({
  children,
  className = "",
  onClick,
  deployUrl,
  disableScale = false,
  disableCursor = false,
}: GridBackgroundProps) {
  // Common content
  const content = (
    <div className={cx("card h-full", disableCursor && "!cursor-default")}>
      <div className="shine"></div>
      <div className="background" style={{ pointerEvents: "none" }}>
        <div className="tiles">
          <div className="tile tile-1"></div>
          <div className="tile tile-2"></div>
          <div className="tile tile-3"></div>
          <div className="tile tile-4"></div>

          <div className="tile tile-5"></div>
          <div className="tile tile-6"></div>
          <div className="tile tile-7"></div>
          <div className="tile tile-8"></div>

          <div className="tile tile-9"></div>
          <div className="tile tile-10"></div>
          <div className="tile tile-11"></div>
          <div className="tile tile-12"></div>

          <div className="tile tile-13"></div>
          <div className="tile tile-14"></div>
          <div className="tile tile-15"></div>
          <div className="tile tile-16"></div>
        </div>

        <div className="line line-1"></div>
        <div className="line line-2"></div>
        <div className="line line-3"></div>
        <div className="line line-4"></div>
      </div>
      <div className={className}>{children}</div>
    </div>
  );

  // If deployUrl is provided, wrap in an anchor tag for link behavior
  if (deployUrl) {
    return (
      <a
        href={deployUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={cx(
          "relative transition-all duration-300 block no-underline",
          !disableScale && "hover:scale-105",
        )}
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  // Otherwise fallback to div
  return (
    <div
      className={cx(
        "relative transition-all duration-300",
        !disableScale && "hover:scale-105",
      )}
      onClick={onClick}
    >
      {content}
    </div>
  );
}
